import { cn } from '@workspace/ui/lib/utils';
import { type ReactNode, useRef, useState } from 'react';

interface CollapsibleListProps {
  itemsToShow: ReactNode[];
  itemsToHide: ReactNode[];
  showMoreText?: string;
  showLessText?: string;
  buttonContainerClassName?: string;
  buttonClassName?: string;
  sublistClassNameCollapsible?: string;
  onToggle?: (isOpen: boolean) => void;
}

export const CollapsibleList = ({
  itemsToShow,
  itemsToHide,
  showMoreText = 'Show more',
  showLessText = 'Show less',
  buttonContainerClassName,
  buttonClassName,
  sublistClassNameCollapsible,
  onToggle,
}: CollapsibleListProps) => {
  const [isListOpen, setIsListOpen] = useState(false);
  const collapsibleRef = useRef<HTMLDivElement>(null);
  const baseRef = useRef<HTMLSpanElement>(null);

  const expandButtonHandler = () => {
    const nextState = !isListOpen;
    setIsListOpen(nextState);
    if (isListOpen && baseRef?.current) {
      const position =
        window.scrollY + baseRef.current.getBoundingClientRect().top - 220;
      if (position) {
        window.scrollTo({
          top: position,
          left: 0,
          behavior: 'smooth',
        });
      }
    }
    onToggle?.(nextState);
  };

  return (
    <>
      <span style={{ position: 'absolute' }} ref={baseRef} />
      {itemsToShow}
      {itemsToHide.length > 0 && (
        <div
          className={cn(sublistClassNameCollapsible)}
          style={{
            height:
              !isListOpen || !collapsibleRef
                ? '0px'
                : `${collapsibleRef.current?.offsetHeight}px`,
          }}
        >
          <div ref={collapsibleRef}>{itemsToHide}</div>
        </div>
      )}
      {itemsToHide.length > 0 && (
        <div className={cn(buttonContainerClassName)}>
          <button className={cn(buttonClassName)} onClick={expandButtonHandler}>
            {isListOpen ? showLessText : showMoreText}
          </button>
        </div>
      )}
    </>
  );
};
